import { useEffect } from "react";

const AdSenseAd = ({ client, slot }) => {
  useEffect(() => {
    try {
      // Esta línea es la clave para registrar el bloque de anuncio
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("AdSense error:", e);
    }
  }, [client, slot]);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default AdSenseAd;
